import { render, staticRenderFns } from "./ProjectsDashboard.vue?vue&type=template&id=42cab470&scoped=true"
import script from "./ProjectsDashboard.vue?vue&type=script&lang=js"
export * from "./ProjectsDashboard.vue?vue&type=script&lang=js"
import style0 from "./ProjectsDashboard.vue?vue&type=style&index=0&id=42cab470&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cab470",
  null
  
)

export default component.exports